// 화면 그리기(§9.8.4) — **화면 + 그림 PNG 저장**. 원격 화면 원래 해상도로 합성한다.
//
// - 흰 판이 아니면: 지금 영상 프레임 → 그 위에 문서(화면 층).
// - 흰 판이면: 흰 바탕 + 흰 판 층(영상은 넣지 않는다 — 사람이 보고 있던 것이 흰 판이다).
// - 선택 표시·레이저·그리는 중인 획은 넣지 않는다(설명 결과물이지 작업 중 화면이 아니다).
// - 원격지 그림이 영상에 이미 찍혀 오는 기기(캡처 제외 불가)에서는 원격지 작성분을 다시 그리지 않는다 — 화면과 같은 규칙(`drawDocument`).
import { drawDocument } from './render.ts';
import type { Author, DrawDoc } from './model.ts';

/** 영상이 아직 없을 때(흰 판만 저장 등)의 크기 — 좌표가 1080 기준이라 그 비율로 둔다. */
const FALLBACK_SIZE = { w: 1920, h: 1080 };
export const SNAPSHOT_MIME = 'image/png';
/** 저장 파일 이름 앞머리(`화면그리기-<기기>-<시각>.png`). */
export const SNAPSHOT_PREFIX = '화면그리기';

/**
 * 합성한 캔버스를 만든다(DOM 필요 — 브라우저 전용).
 * @param video 원격 화면 `<video>`(없거나 아직 프레임이 없으면 흰 판처럼 바탕 없이 그린다)
 */
export function composeSnapshot(
  video: HTMLVideoElement | null,
  doc: DrawDoc,
  hideAuthor: Author | null,
): HTMLCanvasElement {
  const hasFrame = !!video && video.videoWidth > 0 && video.videoHeight > 0;
  const s = hasFrame ? { w: video!.videoWidth, h: video!.videoHeight } : FALLBACK_SIZE;
  const c = document.createElement('canvas');
  c.width = s.w;
  c.height = s.h;
  const ctx = c.getContext('2d');
  if (!ctx) return c;
  if (!doc.board && hasFrame) ctx.drawImage(video!, 0, 0, s.w, s.h);
  drawDocument(ctx, doc, s, hideAuthor);
  return c;
}

/** 캔버스 → PNG 바이트. */
export function canvasToPng(c: HTMLCanvasElement): Promise<Blob> {
  return new Promise((resolve, reject) =>
    c.toBlob((b) => (b ? resolve(b) : reject(new Error('PNG 로 만들지 못했습니다'))), SNAPSHOT_MIME),
  );
}
